/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Saisissez quelque chose…',
  'fabric.editor.editorAssistiveLabel': 'Zone de contenu principale, commencez à taper pour saisir du texte.',
  'fabric.editor.headingLink.toolbarHelpTitle': "Ouvrir la boîte de dialogue d'aide",
};
